import React from "react";
import { styled } from "@material-ui/styles";
import Link from "../link";
import { ITeam } from "../../types";
import { IStyledArguments } from "../../types/styled-arguments";

/*
 * Trail sobre la foto del hero: texto claro sin tarjeta propia,
 * para que conviva con el título del equipo sin solaparse.
 */
const Trail = styled("div")(({ theme }: IStyledArguments) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(0.75),
  fontSize: "0.85rem",
  fontWeight: 500,
  color: "rgba(255, 255, 255, 0.8)",
  "& a": {
    color: "#ffffff",
    fontWeight: 600,
    textDecoration: "none",
  },
  "& a:hover": {
    textDecoration: "underline",
  },
}));

const Breadcrumb = ({ team }: { team: ITeam }) => {
  return (
    <Trail>
      <Link color="inherit" to="/">
        Teams
      </Link>
      <span>/</span>
      <span>{team.name}</span>
    </Trail>
  );
};

export default Breadcrumb;
